<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/planned-maintenance/general-item-inventories"
          ></back-button>
          Update General Item / Inventory
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">
            <router-link :to="`/planned-maintenance/general-item-inventories`"
              >General Item / Inventorys</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Vessel</label>
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.vessel_id"
                      :suggestions="vessels"
                      placeholder="Select vessel"
                    ></my-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Category</label>
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.category_id"
                      :suggestions="categories"
                      placeholder="Select category"
                    ></my-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Item Name</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.item_name"
                      class="form-control"
                      placeholder="Item name"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Item Code</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.item_code"
                      class="form-control"
                      placeholder="Item code"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Make</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.make"
                      class="form-control"
                      placeholder="Make"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Part Number</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.part_number"
                      class="form-control"
                      placeholder="Part Number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Draw Number</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.draw_number"
                      class="form-control"
                      placeholder="Draw Number"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Model Number</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.model_number"
                      class="form-control"
                      placeholder="Model Number"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Serial Number</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.serial_number"
                      class="form-control"
                      placeholder="Serial Number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Measure</label>
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.measure_id"
                      :suggestions="measures"
                      placeholder="Select measure"
                    ></my-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Expiry Date</label>
                  <div class="col-sm-8">
                    <my-datepicker
                      :date.sync="form.expiry_date"
                      placeholder="Enter Expiry Date"
                    ></my-datepicker>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Location On Board</label
                  >
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.location_on_board_id"
                      :suggestions="location_on_boards"
                      placeholder="Select location on board"
                    ></my-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1">
                <div class="row mb-1">
                  <label class="col-sm-12 col-form-label">Is Critical</label>
                  <div class="form-check form-switch mb-2">
                    <input
                      type="checkbox"
                      v-model="form.is_critical"
                      class="form-check-input"
                      id="formSwitch1"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-1">
                <div class="row mb-1">
                  <label class="col-sm-12 col-form-label">Is SOPEP</label>
                  <div class="form-check form-switch mb-1">
                    <input
                      type="checkbox"
                      v-model="form.is_sopep_item"
                      class="form-check-input"
                      id="formSwitch1"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">Remarks</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.remarks"
                      class="form-control"
                      placeholder="Remarks"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Attachment</label>
                  <div class="col-sm-8">
                    <input
                      type="file"
                      ref="file"
                      name="file"
                      multiple
                      class="form-control"
                      placeholder="Remarks"
                    />
                  </div>
                </div>
              </div>
            </div>
            <h4><i class="link-arrow" data-feather="edit"></i> Procurement</h4>
            <hr />
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Average Price (USD)</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.average_price"
                      class="form-control"
                      placeholder="Average Price"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Latest Price (USD)</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.average_price"
                      class="form-control"
                      placeholder="Latest Price"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Current Price (USD)</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.average_price"
                      class="form-control"
                      placeholder="Current Price"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Supplier Name</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.supplier_name"
                      class="form-control"
                      placeholder="Supplier Name"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">PO Number </label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.po_number"
                      class="form-control"
                      placeholder="PO Number"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <h4>
              <i class="link-arrow" data-feather="edit"></i> Quantities on board
            </h4>
            <hr />
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Minimum alarm level</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.min_alarm_level"
                      class="form-control"
                      placeholder="Minimum alarm level"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Maximum alarm level</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.max_alarm_level"
                      class="form-control"
                      placeholder="Maximum alarm level"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Consumed Quantity</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.consumed_quantity"
                      class="form-control"
                      placeholder="Consumed Quantity"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">ROB</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.rob"
                      class="form-control"
                      placeholder="ROB"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="row mb-1">
                  <label class="col-sm-12 col-form-label"
                    >Is Tracker Item</label
                  >
                  <div class="form-check form-switch mb-2">
                    <input
                      type="checkbox"
                      v-model="form.is_tracked_item"
                      class="form-check-input"
                      id="formSwitch6"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "ConsumptionTypeUpdate",
  data() {
    return {
      form: {
        vessel_id: "",
        measure_id: "",
        location_on_board_id: "",
        category_id: "",
      },
      vessels: [],
      measures: [],
      categories: [],
      location_on_boards: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("general_item_inventories/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      masters.measures.forEach((measure) => {
        this.measures.push({
          id: measure.id,
          name: measure.name,
        });
      });
      masters.location_on_boards.forEach((location_on_board) => {
        this.location_on_boards.push({
          id: location_on_board.id,
          name: location_on_board.name,
        });
      });
      masters.categories.forEach((category) => {
        this.categories.push({
          id: category.id,
          name: category.name,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/general_item_inventories/${this.$route.params.general_item_inventory_Id}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.patch(
          `/general_item_inventories/${this.$route.params.general_item_inventory_Id}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/planned-maintenance/general-item-inventories");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
